import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/sgtec/fornecedores/pagamentos?dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/fornecedores/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterEtapasDisponiveis(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/sgtec/fornecedores/pagamentos/${pagamentoId}/etapasdisponiveis`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDespesasDisponiveis(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/sgtec/fornecedores/pagamentos/${pagamentoId}/despesasdisponiveis`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    associarEtapas(pagamentoEtapas) {
        return axiosJwt
            .post(
                `${api}/sgtec/fornecedores/pagamentos/${pagamentoEtapas.pagamentoId}/associaretapas`,
                pagamentoEtapas
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    desassociarEtapa(pagamentoEtapa) {
        return axiosJwt
            .post(
                `${api}/sgtec/fornecedores/pagamentos/${pagamentoEtapa.pagamentoId}/desassociaretapa`,
                pagamentoEtapa
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    associarDespesas(pagamentoDespesas) {
        return axiosJwt
            .post(
                `${api}/sgtec/fornecedores/pagamentos/${pagamentoDespesas.pagamentoId}/associardespesas`,
                pagamentoDespesas
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    desassociarDespesa(pagamentoDespesa) {
        return axiosJwt
            .post(
                `${api}/sgtec/fornecedores/pagamentos/${pagamentoDespesa.pagamentoId}/desassociardespesa`,
                pagamentoDespesa
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamento() {
        return axiosJwt
            .post(`${api}/sgtec/fornecedores/pagamentos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos() {
        return axiosJwt
            .get(`${api}/sgtec/fornecedores/pagamentos/anexos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoId', pagamentoAnexo.tipoId)
        formData.append('descritivo', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)

        return axiosJwt
            .post(
                `${api}/sgtec/fornecedores/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(pagamentoAnexo) {
        return axiosJwt
            .put(
                `${api}/sgtec/fornecedores/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                pagamentoAnexo
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviarPagamentoParaAnalise(pagamentoDto) {
        return axiosJwt
            .post(`${api}/sgtec/fornecedores/pagamentos/enviar`, pagamentoDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(
                `${api}/sgtec/fornecedores/pagamentos/anexos/${pagamentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/fornecedores/pagamentos/${pagamentoId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterNotasFiscais(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/fornecedores/pagamentos/${pagamentoId}/notasfiscais`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoNotaFiscal(notaFiscal) {
        const formData = new FormData()
        Object.keys(notaFiscal).forEach(chave => {
            if (notaFiscal[chave] !== null && notaFiscal[chave] !== undefined) {
                formData.append(chave, notaFiscal[chave])
            }
        })

        return axiosJwt
            .post(
                `${api}/sgtec/fornecedores/pagamentos/${notaFiscal.pagamentoId}/notasfiscais`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirNotaFiscal(pagamentoId, pagamentoNotaFiscalId) {
        return axiosJwt
            .delete(`${api}/sgtec/fornecedores/pagamentos/${pagamentoId}/notasfiscais/${pagamentoNotaFiscalId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadNotaFiscal(pagamentoNotaFiscalId) {
        return axiosJwt
            .get(`${api}/sgtec/fornecedores/pagamentos/notasfiscais/${pagamentoNotaFiscalId}/baixar`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }

}
